import { createSlice } from "@reduxjs/toolkit";

export const genreOrCategory = createSlice({
  name: "genreOrCategory",
  initialState: {
    genreIdOrCategoryName: "",
    page: 1,
    searchQuery: "",
  },
  reducers: {
    selectGenreOrCategory: (state, action) => {
      state.genreIdOrCategoryName = action.payload;
      state.searchQuery = "";
      // console.log(action.payload);
    },
    SearchMovie: (state, action) => {
      state.searchQuery = action.payload;
    },
  },
});
export const { selectGenreOrCategory, SearchMovie } = genreOrCategory.actions;
export default genreOrCategory.reducer;
